export interface ChartTypes {
  height: number;
  heightWithoutTitle: number;
  heightWithoutTitleSkeleton: number;
  imagesHeight: number;
}

export const charts: ChartTypes = {
  height: 320,
  heightWithoutTitle: 363,
  imagesHeight: 250,
  get heightWithoutTitleSkeleton() {
    return this.heightWithoutTitle - 18;
  }
};
